<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <NavBar />
    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar'

export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue